import { DeactivatedUsersTable } from 'src/features/userManagement/components/table/DeactivatedUsersTable.tsx';

const DeactivatedUsers = () => {
    return <DeactivatedUsersTable />;
};

export default DeactivatedUsers;
